import { Col, Container, Row } from 'react-bootstrap'
import { Breadcrumb } from '../../../components/Breadcrumb/Breadcrumb'
import { CTAButton, SavingButton, Tooltip, WhyUsCaption, WhyUsCol, WhyUsImage, WhyUsSection, WhyUsText, WhyUsTitle } from './WhyUs.styles'
import railcardVirginPoints from '../../../img/graphic-railcard-virgin-points.svg'
import railcardOfficialRetailer from '../../../img/graphic-railcard-official-retailer.svg'
import railcardSavings from '../../../img/graphic-railcard-savings.svg'
import railcardDigitalCard from '../../../img/graphic-railcard-digital-card.svg'
import React, { useState } from 'react'
import { shift, useFloating, useFocus, useHover, useInteractions } from '@floating-ui/react'
import { usePurchaseURLGenerator } from '../../../util/hooks/usePurchaseURLGenerator'

export const WhyUs = () => {
  const [isSavingTooltipOpen, setIsSavingTooltipOpen] = useState(false)
  const { refs, floatingStyles, context } = useFloating({
    middleware: [shift()],
    open: isSavingTooltipOpen,
    onOpenChange: setIsSavingTooltipOpen,
  })
  const hover = useHover(context)
  const focus = useFocus(context)
  const { getReferenceProps, getFloatingProps } = useInteractions([hover, focus])
  const generatePurchaseRailcardURL = usePurchaseURLGenerator()
  const purchaseRailcardURL = generatePurchaseRailcardURL('VTTWebsite', 'VTTWebsite-WhyUsSection', 'VTTWebsite')

  return (
    <WhyUsSection>
      <Container>
        <Row>
          <Col>
            <Breadcrumb items={[{ text: 'Railcards', url: '' }]} />
          </Col>
        </Row>
        <Row>
          <Col>
            <WhyUsTitle>Why buy a Railcard with us?</WhyUsTitle>
          </Col>
        </Row>
        <Row>
          <WhyUsCol md={6} lg={3}>
            <WhyUsImage src={railcardVirginPoints} />
            <WhyUsCaption>
              Earn Virgin Points when <br />
              you buy a Railcard
            </WhyUsCaption>
            <WhyUsText>
              You’ll need a free Virgin Red account to collect points. Once you’re in, those points can go towards cheaper train journeys or
              epic rewards from Virgin and brands you love.
            </WhyUsText>
          </WhyUsCol>
          <WhyUsCol md={6} lg={3}>
            <WhyUsImage src={railcardOfficialRetailer} />
            <WhyUsCaption>
              It’s the same Railcard – <br />
              just more rewarding
            </WhyUsCaption>
            <WhyUsText>
              We’re an official National Rail retailer, so nothing changes there. Buy your Railcard with Virgin Trains Ticketing and you’ll
              unlock extra value through Virgin Red.
            </WhyUsText>
          </WhyUsCol>
          <WhyUsCol md={6} lg={3}>
            <WhyUsImage src={railcardSavings} />
            <WhyUsCaption>
              Save 1/3 on eligible <br />
              train journeys
            </WhyUsCaption>
            <WhyUsText>
              Railcards can cut the cost of your tickets by a third. <br />
              With an average annual saving of{' '}
              <SavingButton variant="link" ref={refs.setReference} {...getReferenceProps()}>
                £146*,
              </SavingButton>{' '}
              your Railcard could pay for itself with just a few trips.
            </WhyUsText>
            {isSavingTooltipOpen && (
              <Tooltip ref={refs.setFloating} style={floatingStyles} {...getFloatingProps()}>
                *£146 average annual saving based on the average savings made by combined Railcard holders from April 2022 to March 2023.
                Excludes the price of Railcard.
                <br />
                <br />
                Statistic from National Rail.
              </Tooltip>
            )}
          </WhyUsCol>
          <WhyUsCol md={6} lg={3}>
            <WhyUsImage src={railcardDigitalCard} />
            <WhyUsCaption>
              All in one place, <br />
              right on your phone
            </WhyUsCaption>
            <WhyUsText>
              Your digital Railcard lives in the Virgin Trains Ticketing app, ready whenever you need it — for smoother journeys and cheaper
              fares.
            </WhyUsText>
          </WhyUsCol>
        </Row>
        <Row>
          <Col className="d-flex justify-content-center">
            <CTAButton href={purchaseRailcardURL}>Buy your Railcard now</CTAButton>
          </Col>
        </Row>
      </Container>
    </WhyUsSection>
  )
}
